import { Image } from '../../state';
import { ImageActionType } from './image-action-type';

export interface LoadImageAction {
  imageKey: string;
  type: ImageActionType.Load;
  image: Partial<Image>;
}

export const loadImage = (
  imageKey: string,
  image: Partial<Image>,
): LoadImageAction => ({
  image,
  imageKey,
  type: ImageActionType.Load,
});
